<template>
  <PageContentLayoutOnly>
    <ListVendorRequestConversations :vendorRequestID="parseInt(vendorRequestID)" />
  </PageContentLayoutOnly>
</template>

<script>
import { mapState } from 'vuex'
import PageContentLayoutOnly from '@/containers/PageContentLayoutOnly'
import ListVendorRequestConversations from '@/pages/Shared/communications/Global/List'

import { methods } from './keys/methods'
import { data } from './keys/data'

export default {
  name: 'VendorRequestConversations',

  components: {
    PageContentLayoutOnly,
    ListVendorRequestConversations
  },

  data,
  methods,

  computed: {
    ...mapState({
      hoaId: state => state.user.selectedHoaId
    })
  },

  watch: {},

  mounted() {
    this.reload()
  },

  i18n: {
    messages: {
      en: { vendorRequestConversations: { title: 'Conversations' } }
    }
  }
}
</script>

<style></style>
